<template>
  <div>
    <div
      class="col-lg-12"
      style="padding-top: 20px; padding-bottom: 20px"
    ></div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-5">
          <card class="card-eprf">
            <div class="col-lg-12">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                DOWNLOAD FORMS
              </p>
              <div class="row" style="margin: 10px">
                <div class="col-lg-8">
                  <p style="color: #A5A5A5">Advance Notification Form</p>
                </div>
                <div class="col-lg-4">
                  <base-button type="primary" v-on:click="getDownload()"
                    >Download</base-button
                  >
                </div>
              </div>
              <div class="row" style="margin: 10px">
                <div class="col-lg-8">
                  <p style="color: #A5A5A5">Waste Collection Order</p>
                </div>
                <div class="col-lg-4">
                  <base-button type="primary" v-on:click="getDownload()"
                    >Download</base-button
                  >
                </div>
              </div>
              <div class="row" style="margin: 10px">
                <div class="col-lg-8">
                  <p style="color: #A5A5A5">Waste Collection Report</p>
                </div>
                <div class="col-lg-4">
                  <base-button type="primary" v-on:click="getDownload()"
                    >Download</base-button
                  >
                </div>
              </div>
              <div class="row" style="margin: 10px">
                <div class="col-lg-8">
                  <p style="color: #A5A5A5">Waste Delivery Order</p>
                </div>
                <div class="col-lg-4">
                  <base-button type="primary" v-on:click="getDownload()"
                    >Download</base-button
                  >
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import Card from "../../../components/Cards/Card.vue";

export default {
  name: "Forms",

  components: {
    Card,
  },

  data() {
    return {};
  },
  methods: {
    getDownload() {},
  },
  created() {},
  computed: {},
};
</script>
<style></style>
